var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"pageSatatus"},[_c('iframe',{attrs:{"src":`https://grap.giikin.cn/#/mail-list?_token=${_vm.token}&_user=${_vm.user}`,"frameborder":"0"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }